import { Outlet } from "react-router-dom";
import { ForcePasswordChangePage } from "@/auth/ForcePasswordChangePage";
import { useSession } from "./SessionContext";

// Nested inside RequireAuth (see App.tsx) — blocks every authenticated route
// behind a mandatory password rotation when the session carries
// mustChangePassword=true (set at login for an agent/admin-onboarded
// account, see lendcord-core's User.mustChangePassword). Deliberately
// renders the gate page in place rather than redirecting to a dedicated
// route: there's no URL a "must change password" state should be
// bookmarkable at, and rendering in place means the originally requested
// page appears immediately once the flag clears, no extra navigation.
export function ForcedPasswordChangeGate() {
  const { mustChangePassword } = useSession();

  if (mustChangePassword) {
    return <ForcePasswordChangePage />;
  }

  return <Outlet />;
}
